module.exports = __webpack_public_path__ + "img/1.7e4f5ec6.jpg";